export const LandscapeStreamline = (
    props: React.SVGProps<SVGSVGElement>
  ) => {
    return (
      <svg
        {...props}
        width="1em"
        height="1em"
        viewBox="0 0 48 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g id="Landscape-1--Streamline-Core.svg">
          <g id="landscape-1--photos-photo-landscape-picture-photography-camera-pictures-image">
            <path
              id="Subtract"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M41.4065 46.2857C44.1013 46.2857 46.2857 44.1014 46.2857 41.4065V6.59341C46.2857 3.89873 44.1013 1.71428 41.4065 1.71428H6.59337C3.89868 1.71428 1.71423 3.89873 1.71423 6.59341V41.4065C1.71423 44.1014 3.89868 46.2857 6.59337 46.2857H41.4065ZM31.6799 10.1786C28.307 10.1786 25.5728 12.9128 25.5728 16.2857C25.5728 19.6586 28.307 22.3929 31.6799 22.3929C35.0526 22.3929 37.7869 19.6586 37.7869 16.2857C37.7869 12.9128 35.0526 10.1786 31.6799 10.1786ZM41.4065 42C41.7342 42 42 41.7343 42 41.4065V32.5006C40.2387 32.109 38.437 31.911 36.6277 31.912C35.33 31.9092 34.0375 32.0075 32.7615 32.2046C34.803 35.1562 36.2965 38.4741 37.1468 42H41.4065ZM24.4204 29.4449C28.4233 32.6905 31.3107 37.0807 32.7161 42H6.59337C6.26563 42 5.99995 41.7343 5.99995 41.4065V23.9491C6.70719 23.8938 7.41677 23.8667 8.12697 23.8681C14.0468 23.7393 19.8207 25.7154 24.4204 29.4449Z"
              fill="currentcolor"
            />
          </g>
        </g>
      </svg>
    );
  };
  